const TOKEN_KEY = 'token'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem('nickname')
  localStorage.removeItem('userId')
}
